<template>
  <div class="knowledge-practice-clazz-detail-page">
    <title-bar back title="答题表现">
      <el-button type="primary" @click="viewPlan">查看计划</el-button>
    </title-bar>

    <div class="main">
      <training-overview-info v-if="training" :training="training"></training-overview-info>
      <training-clazz-static-info :clazz-summary-items="clazzSummaryItems"></training-clazz-static-info>
      <list-page class="list-page" :data="transferSummaryItems" :limit="query.limit">
        <el-table-column label="班级">
          <template v-slot="{ row }">
            {{ showClazzName(row.class_vo) }}
          </template>
        </el-table-column>

        <el-table-column label="人数">
          <template v-slot="{ row }">
            {{ row.completion_count + row.uncompleted_count }}
          </template>
        </el-table-column>

        <el-table-column label="完成人数">
          <template v-slot="{ row }">
            {{ row.completion_count }}
          </template>
        </el-table-column>
        <el-table-column label="完成率">
          <template v-slot="{ row }">
            <div class="finish-rate" :style="service.participatedRateColor(row.completion_rate * 100)">
              {{ formatRate(row.completion_rate / 100) }}%
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="action" label="更多操作" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="navToClazzStudentStatic(row.challenge_class_id)">详情</el-button>
          </template>
        </el-table-column>
      </list-page>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import ListPage from '@/components/ListPage.vue'
import { Clazz, HomeworkClazzStat, IClazzStaticSummary, ITrainingListItem } from 'kuaidong-model'
import { Emit } from 'vue-property-decorator'
import { AWinter2023 } from 'kuaidong-api'
import { DateWrapper, SchoolUtil, UnitUtil } from 'kuaidong-lib'
import { NewCourseLiveService } from 'kuaidong-service'

@Component({
  components: {
    TitleBar,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
    ListPage,
  },
})
export default class KnowledgePracticeClazzDetailPage extends BasePage {
  @Prop({ type: Object, required: true })
  training!: ITrainingListItem

  @Prop({ type: String, required: true })
  from!: 'KNOWLEDGE' | 'SPECIAL_EXERCISE'

  staticInfo: IClazzStaticSummary | null = null
  summaryItems: IClazzStaticSummary[] = []
  query = {
    limit: 20,
  }

  get service() {
    return NewCourseLiveService
  }

  get transferSummaryItems() {
    return this.summaryItems.map((item) => {
      return {
        ...item,
      }
    })
  }

  get clazzOptions() {
    return this.summaryItems.map((item) => {
      return {
        challenge_id: item.challenge_id,
        challenge_class_id: item.challenge_class_id,
        label: item.class_vo?.note_name || item.class_vo?.name,
        value: item.class_vo?.id,
      }
    })
  }

  get clazzSummaryItems() {
    if (this.staticInfo === null) {
      return [
        { value: '-', title: '学生人数' },
        { value: '-', title: '已完成' },
        { value: '-', title: '未完成' },
        { value: '-', title: '完成率' },
      ]
    } else {
      return [
        { value: this.staticInfo?.students_count, title: '学生人数' },
        { value: this.staticInfo?.completion_count, title: '已完成' },
        { value: this.staticInfo?.uncompleted_count, title: '未完成' },
        { value: this.staticInfo.completion_rate, title: '完成率' },
      ]
    }
  }

  async created() {
    this.fetchClazzStaticInfo()
    this.fetchClazzSummaryList()
  }

  formatDate(dt: string) {
    return new DateWrapper(dt).showDateStrShort3
  }

  @Emit('navToDetail')
  handleClick(item: HomeworkClazzStat) {
    return item
  }

  async fetchClazzStaticInfo() {
    this.staticInfo = await AWinter2023.trainingClassSummary(this.training.group_id)
  }

  async fetchClazzSummaryList() {
    this.summaryItems = await AWinter2023.trainingClassSummaryList(this.training.group_id)
  }

  navToClazzStudentStatic(challengeClassId: string) {
    this.$router.push({
      name: 'pe_knowledge_practice_student_detail',
      query: {
        training: JSON.stringify(this.training),
        clazzOptions: JSON.stringify(this.clazzOptions),
        challengeClassId,
        from: this.from,
      },
    })
  }

  viewPlan() {
    if (this.from === 'KNOWLEDGE') {
      this.$router.push({
        name: 'pe_knowledge_exam_detail',
        query: {
          id: this.staticInfo?.paper_id,
        },
      })
    }
  }

  showClazzName(clazz: Clazz) {
    return clazz.note_name || clazz.name || SchoolUtil.buildClazzName(clazz.grade_no, clazz.class_no)
  }

  formatRate(rate: number) {
    return UnitUtil.percent(rate)
  }
}
</script>
<style lang="less">
.knowledge-practice-clazz-detail-page {
  > .main {
    padding: 22px 24px;
    background: #fff;

    > .list-page {
      margin-top: 24px;
      padding: 0;
    }
  }
}
</style>
